export const fakeBusinessChatroomId = 'fake-businessId';
